export default {
	"superAddressComp": {
		"pickUpPoint": "提货点"
	},
	"tempSpanComp": {
		"noLimit": "不限"
	},
	"searchComp": {
		"orderNo": "运输订单:",
		"transportNo": "运单:",
		"taskNo": "任:",
		"originNo": "外:",
		"transferNo": "交:",
		"routeNo": "派:"
	}
}


// WEBPACK FOOTER //
// ./src/lang/zh-CN/components/searchComponent/searchComponent.js